import { render, staticRenderFns } from "./ChangeTitle.vue?vue&type=template&id=5499eef2&scoped=true&"
import script from "./ChangeTitle.vue?vue&type=script&lang=js&"
export * from "./ChangeTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499eef2",
  null
  
)

export default component.exports